module.exports = __webpack_public_path__ + "static/media/arrow-right.7ecb0fa2.svg";